module.exports = __webpack_public_path__ + "static/029_Gippsland-4a98dbfcb50c8b50390e97aa4d8446eb.png";